import { useState } from "react";
import { useForm } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import CreateFolderForm from "containers/admin/clients/campaign/campaign-creative-page/components/create-folder/create-folder-form/create-folder-form";

const EditFolderModal = ({
  folderName,
  onCloseCallback,
  onConfirmCallback,
  isSubmitting = false,
}: {
  folderName?: string;
  onCloseCallback: () => void;
  onConfirmCallback: (data: { name: string }) => void;
  isSubmitting: boolean;
}) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const form = useForm<{ name: string }>({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues: { name: folderName },
  });

  return (
    <FormDialog
      open
      onClose={onCloseCallback}
      headline="Edit folder"
      form={form}
      onSubmit={onConfirmCallback}
      submitDisabled={isSubmitDisabled}
      submitting={isSubmitting}
      submitButtonText="Save changes">
      <CreateFolderForm
        setIsSubmitDisabled={setIsSubmitDisabled}
        touchpointsNotIncluded
        currentFolderName={folderName}
      />
    </FormDialog>
  );
};

export default EditFolderModal;
